import Swiper from "swiper";
import { A11y, Autoplay, EffectFade } from "swiper/modules";
import { inView } from "motion";
import "@styles/components/slider.css";

document.querySelectorAll(".element-steps").forEach((el) => {
  const slider = el.querySelector(".swiper");

  const swiper = new Swiper(slider, {
    modules: [A11y, Autoplay, EffectFade],
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    speed: 300,
  });

  el.querySelectorAll(".step-trigger").forEach((trigger) => {
    trigger.addEventListener("click", () => {
      if (trigger.getAttribute("aria-selected") === "false") {
        const currentTrigger = el.querySelector('.step-trigger[aria-selected="true"]');

        const index = parseInt(trigger.dataset.index);

        currentTrigger.setAttribute("aria-selected", "false");
        trigger.setAttribute("aria-selected", "true");

        swiper.slideTo(index - 1);
        activateSlide();
      }
    });
  });

  const activateSlide = () => {
    const activeSlide = swiper.slides[swiper.activeIndex];

    const video = activeSlide.querySelector("video");
    const object = activeSlide.querySelector("object");

    if (video) {
      video.load();
      video.play();
    }

    if (object) {
      const data = object.getAttribute("data");
      object.setAttribute("data", "");
      object.offsetHeight;
      object.setAttribute("data", data);
    }
  };

  inView(
    el,
    () => {
      activateSlide();
    },
    {
      margin: "0px 0px -25% 0px",
    },
  );
});
